export default __webpack_public_path__ + "static/media/product-11 (1).2976e7fe.jpg";